module.exports = __webpack_public_path__ + "assets/img/gongzhonghao-42cf9185.png";